export enum PDragAndDropListVariant {
  ROW = 'row',
  CARD = 'card',
}
